import React from 'react';

export const RichTextItalicIcon = ({
  width = 24,
  height = 24,
  className = 'fill-black',
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.76 9H13.76L11.56 19H9.56L11.76 9ZM13.44 5C13.2422 5 13.0489 5.05865 12.8844 5.16853C12.72 5.27841 12.5918 5.43459 12.5161 5.61732C12.4404 5.80004 12.4206 6.00111 12.4592 6.19509C12.4978 6.38907 12.593 6.56725 12.7329 6.70711C12.8727 6.84696 13.0509 6.9422 13.2449 6.98079C13.4389 7.01937 13.64 6.99957 13.8227 6.92388C14.0054 6.84819 14.1616 6.72002 14.2715 6.55557C14.3813 6.39112 14.44 6.19778 14.44 6C14.44 5.73478 14.3346 5.48043 14.1471 5.29289C13.9596 5.10536 13.7052 5 13.44 5Z" />
  </svg>
);
